var map = {
	".": "5ECq",
	"./": "5ECq",
	"./00_post_trade_order_test": "TrnZ",
	"./00_post_trade_order_test.json": "TrnZ",
	"./01_post_trade_order": "YLkf",
	"./01_post_trade_order.json": "YLkf",
	"./01_post_trade_order_vst": "dww0",
	"./01_post_trade_order_vst.json": "dww0",
	"./02_post_edit_order": "plpn",
	"./02_post_edit_order.json": "plpn",
	"./02_post_trade_batch_order": "/bqr",
	"./02_post_trade_batch_order.json": "/bqr",
	"./03_post_closeAllPositions": "jBL/",
	"./03_post_closeAllPositions.json": "jBL/",
	"./04_delete_trade_order": "nf3C",
	"./04_delete_trade_order.json": "nf3C",
	"./05_delete_trade_batch_order": "siG2",
	"./05_delete_trade_batch_order.json": "siG2",
	"./06_delete_trade_all_order": "/Fs7",
	"./06_delete_trade_all_order.json": "/Fs7",
	"./07_get_all_openOrders": "jxdV",
	"./07_get_all_openOrders.json": "jxdV",
	"./08_check_pending_order": "fLAw",
	"./08_check_pending_order.json": "fLAw",
	"./08_get_trade_order": "1xud",
	"./08_get_trade_order.json": "1xud",
	"./09_get_trade_marginType": "Qa4f",
	"./09_get_trade_marginType.json": "Qa4f",
	"./10_post_trade_marginType": "WCFx",
	"./10_post_trade_marginType.json": "WCFx",
	"./11_get_trade_leverage": "Nux4",
	"./11_get_trade_leverage.json": "Nux4",
	"./12_post_trade_leverage": "j3Xb",
	"./12_post_trade_leverage.json": "j3Xb",
	"./13_get_trade_forceOrders": "fUN5",
	"./13_get_trade_forceOrders.json": "fUN5",
	"./14_get_trade_allOrders": "iu9b",
	"./14_get_trade_allOrders.json": "iu9b",
	"./15_post_trade_positionMargin": "i3k4",
	"./15_post_trade_positionMargin.json": "i3k4",
	"./17_get_trade_allFillOrders": "1A8u",
	"./17_get_trade_allFillOrders.json": "1A8u",
	"./18_set_positionSide": "wp4b",
	"./18_set_positionSide.json": "wp4b",
	"./19_get_positionSide": "n7WW",
	"./19_get_positionSide.json": "n7WW",
	"./20_cancel_replace_order": "vKvg",
	"./20_cancel_replace_order.json": "vKvg",
	"./21_batch_cancel_replace_order": "nNrq",
	"./21_batch_cancel_replace_order.json": "nNrq",
	"./22_cancel_all_after": "6Ivy",
	"./22_cancel_all_after.json": "6Ivy",
	"./22_post_closePosition": "JRrP",
	"./22_post_closePosition.json": "JRrP",
	"./23_get_trade_allOrdersV2": "wYbs",
	"./23_get_trade_allOrdersV2.json": "wYbs",
	"./24_get_maint_margin_ratio": "OkoV",
	"./24_get_maint_margin_ratio.json": "OkoV",
	"./25_get_fill_history_detail": "l3pU",
	"./25_get_fill_history_detail.json": "l3pU",
	"./26_get_user_position_history": "xptQ",
	"./26_get_user_position_history.json": "xptQ",
	"./27_get_position_margin_history": "bHz9",
	"./27_get_position_margin_history.json": "bHz9",
	"./27_post_get_vst": "cn9g",
	"./27_post_get_vst.json": "cn9g",
	"./28_post_twap_order": "6+7u",
	"./28_post_twap_order.json": "6+7u",
	"./29_get_twap_open_orders": "2vkv",
	"./29_get_twap_open_orders.json": "2vkv",
	"./30_get_twap_history_orders": "BBsp",
	"./30_get_twap_history_orders.json": "BBsp",
	"./31_get_twap_order_detail": "NQ2q",
	"./31_get_twap_order_detail.json": "NQ2q",
	"./32_cancel_twap_cancel_order": "iXtv",
	"./32_cancel_twap_cancel_order.json": "iXtv",
	"./33_post_asset_mode": "xS3w",
	"./33_post_asset_mode.json": "xS3w",
	"./34_get_asset_mode": "ZFUX",
	"./34_get_asset_mode.json": "ZFUX",
	"./35_get_multi_asset_rule": "jifI",
	"./35_get_multi_asset_rule.json": "jifI",
	"./36_get_margin_asset": "+eKI",
	"./36_get_margin_asset.json": "+eKI",
	"./37_post_trade_reverse": "0tet",
	"./37_post_trade_reverse.json": "0tet",
	"./38_post_auto_add_margin": "PWIR",
	"./38_post_auto_add_margin.json": "PWIR",
	"./index": "5ECq",
	"./index.js": "5ECq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "733f";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/api/trade ^.*$
// module id = 733f
// module chunks = 3